<div class="ipos-receipt-inner-outer">
  <div class="content-box" id="receipt">
    <div class="ipos-reciept-rest-info">

      <!-- <img class="ipos-reciept-rest-logo" [src]="data.restaurant.logo"> -->

      <h2 class="ipos-reciept-rest-name">{{data.restaurant.name}}</h2>
      <p class="ipos-reciept-rest-address">{{data.restaurant.address}}</p>
      <p class="ipos-reciept-rest-num">{{data.restaurant.tel}}</p>
    </div>
    <h5 class="ipos-reciept-title">Receipt</h5>
    <div class="ipos-reciept-content">
      <!-- <div class="ipos-reciept-Info">
        <div class="ipos-reciept-info-item">Date : <span>{{data.invoiceDate | date:'dd-MMM-yyyy'}}</span></div>
        <div class="ipos-reciept-info-item">Time : <span>{{data.invoiceDate | date:'hh:mm a'}}</span></div>
        <div class="ipos-reciept-info-item">Currency : <span>{{data.currency}}</span></div>
        <div class="ipos-reciept-info-item">Staff : <span>{{data.staff}}</span></div>
        <div class="ipos-reciept-info-item">Invoice : <span>#{{data.orderId}}</span></div>
        <div class="ipos-reciept-info-item">Currency : <span>{{data.currency}}</span></div>
      </div> -->
      <div class="ipos-reciept-Info">
        <div class="ipos-reciept-info-group">
          <div class="ipos-reciept-info-item">Date : </div>
          <div class="ipos-reciept-info-item">{{data.invoiceDate | date:'dd-MMM-yyyy'}}</div>
          <div class="ipos-reciept-info-item">Currency : </div>
          <div class="ipos-reciept-info-item">{{data.currency}}</div>
          <div class="ipos-reciept-info-item">Invoice : </div>
          <div class="ipos-reciept-info-item">#{{data.orderId}}</div>
        </div>
        <div class="ipos-reciept-info-group">
          <div class="ipos-reciept-info-item">Time : </div>
          <div class="ipos-reciept-info-item">{{data.invoiceDate | date:'hh:mm a'}}</div>
          <div class="ipos-reciept-info-item">Staff : </div>
          <div class="ipos-reciept-info-item">{{data.staff}}</div>
          <!-- <div class="ipos-reciept-info-item">Currency : <span>{{data.currency}}</span></div> -->
        </div>
      </div>
      <table class="ipos-reciept-table">
        <thead>
          <tr class="ipos-reciept-table-head">
            <th class="ipos-reciept-table-head-item">Sl</th>
            <th class="ipos-reciept-table-head-item" style="width: 100%;">Name</th>
            <th class="ipos-reciept-table-head-item">Qty</th>
            <th class="ipos-reciept-table-head-item">Amt</th>
          </tr>
        </thead>
        <tbody>
          <tr class="ipos-reciept-table-row" *ngFor="let i of data.items;let ix =index">
            <td class="ipos-reciept-table-row-item">{{ix+1}}</td>
            <td class="ipos-reciept-table-row-item">{{i.itemName}}
              <ng-container *ngIf="i.items">
                <ng-container *ngFor="let it of i.items">
                  <br><span> {{it.itemName}}</span>
                </ng-container>
              </ng-container>
            </td>
            <td class="ipos-reciept-table-row-item">{{i.quantity}}</td>
            <td class="ipos-reciept-table-row-item">{{i.price| noDecimal}}</td>
          </tr>

        </tbody>
        <tbody class="ipos-reciept-subtotal">
          <tr class="ipos-reciept-table-row">
            <td colspan="3" class="ipos-reciept-table-row-item">Total</td>
            <td class="ipos-reciept-table-row-item">{{totalBeforeTax() | noDecimal}}</td>
          </tr>
          <tr class="ipos-reciept-table-row">
            <td colspan="3" class="ipos-reciept-table-row-item">Tax</td>
            <td class="ipos-reciept-table-row-item">{{data.tax | noDecimal}}</td>
          </tr>
          <tr class="ipos-reciept-table-row" *ngIf="data.tip">
            <td colspan="3" class="ipos-reciept-table-row-item">Tips</td>
            <td class="ipos-reciept-table-row-item">{{data.tip | noDecimal}}</td>
          </tr>
          <tr class="ipos-reciept-total ipos-reciept-table-row">
            <td colspan="3" class="ipos-reciept-table-row-item">Grand Total</td>
            <td class="ipos-reciept-table-row-item">{{grandTotal() | noDecimal}}</td>
          </tr>
          <tr class="ipos-reciept-table-row" *ngFor="let i of data.payments">
            <td colspan="3" class="ipos-reciept-table-row-item">Online Payment
              <span style="text-transform: lowercase; font-size: 9px;">({{i.referenceNo}})</span> </td>
            <td class="ipos-reciept-table-row-item">{{i.amount | noDecimal}}</td>
          </tr>
          <!-- <tr class="ipos-reciept-table-row ipos-reciept-mini-sum">
            <td colspan="2" class="ipos-reciept-table-row-item">Taxable Amount<br>452.38</td>
            <td class="ipos-reciept-table-row-item">VAT%<br>Tax(5%)</td>
            <td class="ipos-reciept-table-row-item">VAT<br>22.62</td>
          </tr> -->
        </tbody>
        <tbody class="ipos-reciept-Summary">
          <tr class="ipos-reciept-table-row">
            <td class="ipos-reciept-table-row-item" colspan="3">Total No. of Items</td>
            <td class="ipos-reciept-table-row-item">{{data.items.length}}</td>
          </tr>
          <!-- <tr class="ipos-reciept-table-row ipos-reciept-table-date">
                        <td class="ipos-reciept-table-row-item" colspan="4">09-Dec-2022 04:29:04 PM</td>
                    </tr> -->
          <!-- <tr class="ipos-reciept-table-row">
            <td class="ipos-reciept-table-row-item" colspan="2">Cashier</td>
            <td class="ipos-reciept-table-row-item" colspan="2">Cashier</td>
          </tr> -->
          <!-- <tr class="ipos-reciept-table-row ipos-reciept-table-orderTaken">
                        <td class="ipos-reciept-table-row-item" colspan="4">Order taken by: <span>Cashier</span></td>
                    </tr> -->
        </tbody>
      </table>
      <div class="ipos-receipt-footer">
        <!-- <p class="ipos-receipt-footer-token">Token No #13</p> -->
        <p class="ipos-receipt-footer-token">Thank you for your business.!</p>
        <p class="ipos-receipt-footer-token">Powered by <a href="https://www.ipossoft.com" target="_blank">iPOS</a></p>

      </div>
    </div>
  </div>
</div>
<!-- <button (click)="downloadImage()">exp</button> -->
